import { Button, Typography } from "@mui/material";
import { colors } from "../../theme/colors";
import { useTranslation } from "react-i18next";

function ButtonSquare({ text, number, action, ...props }) {
  const { t } = useTranslation();
  switch (action) {
    case "number-active":
      return (
        <Button
          {...props}
          onClick={props.onClick}
          sx={{
            height: "35px",
            width: "40px",
            borderRadius: "4px",
            padding: "0",
            border: "none",
            fontWeight: "500",
            color: "#1D4ED8",
            backgroundColor: `white`,
            "&:hover": {
              border: "none",
              color: "#1D4ED8",
              backgroundColor: `white`,
              fontWeight: "500",
            },
          }}
        >
          <Typography>{number}</Typography>
        </Button>
      );
    case "number":
      return (
        <Button
          {...props}
          onClick={props.onClick}
          sx={{
            color: "black",
            height: "35px",
            width: "40px",
            borderRadius: "4px",
            fontWeight: "500",
            padding: "0",
            border: "none",
            backgroundColor: `white`,
            "&:hover": {
              color: "#1D4ED8",
              border: "none",
              backgroundColor: "white",
              fontWeight: "500",
            },
          }}
        >
          <Typography>{number}</Typography>
        </Button>
      );
    case "Next":
      return (
        <Button
          {...props}
          onClick={props.onClick}
          sx={{
            color: "black",
            height: "35px",
            borderRadius: "4px",
            fontWeight: "500",
            padding: "0px 10px",
            border: "none",
            backgroundColor: `white`,
            "&:hover": {
              color: "#1D4ED8",
              border: "none",
              backgroundColor: "white",
              fontWeight: "500",
            },
          }}
        >
          <Typography
            fontSize="15px"
            lineHeight="18px"
            sx={{ wordSpacing: "5px" }}
          >
            {t("navigations.next")} {">"}
          </Typography>
        </Button>
      );
    case "Previous":
      return (
        <Button
          {...props}
          onClick={props.onClick}
          sx={{
            color: "black",
            height: "35px",
            borderRadius: "4px",
            padding: "0px 10px",
            border: "none",
            fontWeight: "500",
            backgroundColor: `white`,
            "&:hover": {
              color: "#1D4ED8",
              border: "none",
              backgroundColor: "white",
              fontWeight: "500",
            },
          }}
        >
          <Typography
            fontSize="15px"
            lineHeight="18px"
            sx={{ wordSpacing: "5px" }}
          >
            {"< "} {t("navigations.previous")}
          </Typography>
        </Button>
      );
    case "completed":
      return (
        <Button
          {...props}
          onClick={props.onClick}
          sx={{
            color: "rgba(40, 199, 111, 1)",
            height: "35px",
            borderRadius: "4px",
            padding: "0px 10px",
            border: "1px solid rgba(40, 199, 111, 0.16)",
            fontWeight: "500",
            fontSize: "13px",
            backgroundColor: "rgba(40, 199, 111, 0.16)",
            "&:hover": {
              color: "rgba(40, 199, 111, 1)",
              border: "1px solid rgba(40, 199, 111, 0.16)",
              backgroundColor: "rgba(40, 199, 111, 0.16)",
              fontWeight: "500",
            },
          }}
        >
          {text}
        </Button>
      );
    case "default":
      return (
        <Button
          {...props}
          onClick={props.onClick}
          sx={{
            color: "rgba(40, 199, 111, 1)",
            height: "35px",
            borderRadius: "4px",
            padding: "0px 10px",
            border: "1px solid rgba(40, 199, 111, 0.16)",
            fontWeight: "500",
            fontSize: "13px",
            backgroundColor: "rgba(40, 199, 111, 0.16)",
            "&:hover": {
              color: "rgba(40, 199, 111, 1)",
              border: "1px solid rgba(40, 199, 111, 0.16)",
              backgroundColor: "rgba(40, 199, 111, 0.16)",
              fontWeight: "500",
            },
          }}
        >
          {t("pages.payments.default")}
        </Button>
      );
    case "rejected":
      return (
        <Button
          {...props}
          onClick={props.onClick}
          sx={{
            color: "rgba(234, 84, 85, 1)",
            height: "35px",
            borderRadius: "4px",
            padding: "0px 10px",
            border: "1px solid rgba(234, 84, 85, 0.16)",
            fontWeight: "500",
            fontSize: "13px",
            backgroundColor: `rgba(234, 84, 85, 0.16)`,
            "&:hover": {
              color: "rgba(234, 84, 85, 1)",
              border: "1px solid rgba(234, 84, 85, 0.16)",
              backgroundColor: "rgba(234, 84, 85, 0.16)",
              fontWeight: "500",
            },
          }}
        >
          {text}
        </Button>
      );

    case "canceled":
      return (
        <Button
          {...props}
          onClick={props.onClick}
          sx={{
            color: "rgba(234, 84, 85, 1)",
            height: "35px",
            borderRadius: "4px",
            padding: "0px 10px",
            border: "1px solid rgba(234, 84, 85, 0.16)",
            fontWeight: "500",
            fontSize: "13px",
            backgroundColor: `rgba(234, 84, 85, 0.16)`,
            "&:hover": {
              color: "rgba(234, 84, 85, 1)",
              border: "1px solid rgba(234, 84, 85, 0.16)",
              backgroundColor: "rgba(234, 84, 85, 0.16)",
              fontWeight: "500",
            },
          }}
        >
          {text}
        </Button>
      );

    case "failed":
      return (
        <Button
          {...props}
          onClick={props.onClick}
          sx={{
            color: "rgba(234, 84, 85, 1)",
            height: "35px",
            borderRadius: "4px",
            padding: "0px 10px",
            border: "1px solid rgba(234, 84, 85, 0.16)",
            fontWeight: "500",
            fontSize: "13px",
            backgroundColor: `rgba(234, 84, 85, 0.16)`,
            "&:hover": {
              color: "rgba(234, 84, 85, 1)",
              border: "1px solid rgba(234, 84, 85, 0.16)",
              backgroundColor: "rgba(234, 84, 85, 0.16)",
              fontWeight: "500",
            },
          }}
        >
          {text}
        </Button>
      );
    case "pending":
      return (
        <Button
          {...props}
          onClick={props.onClick}
          sx={{
            color: "rgba(255, 159, 67, 1)",
            height: "35px",
            borderRadius: "4px",
            padding: "0px 10px",
            border: "1px solid rgba(234, 84, 85, 0.16)",
            fontWeight: "500",
            fontSize: "13px",
            backgroundColor: `rgba(255, 159, 67, 0.16)`,
            "&:hover": {
              color: "rgba(255, 159, 67, 1)",
              border: "1px solid rgba(255, 159, 67, 0.16)",
              backgroundColor: "rgba(255, 159, 67, 0.16)",
              fontWeight: "500",
            },
          }}
        >
          {text}
        </Button>
      );
    case "canceled_shipping":
      return (
        <Button
          {...props}
          onClick={props.onClick}
          sx={{
            color: "white",

            minHeight: "35px",
            minWidth: "100px",
            borderRadius: "4px",
            padding: "0px 10px",
            border: "1px solid #B00020",
            fontWeight: "500",
            fontSize: "18px",
            backgroundColor: `#B00020`,
            "&:hover": {
              color: "white",
              border: "1px solid #B00020",
              backgroundColor: "#B00020",
              fontWeight: "500",
            },
          }}
        >
          {text}
        </Button>
      );
    case "completed_shipping":
      return (
        <Button
          {...props}
          onClick={props.onClick}
          sx={{
            color: "white",

            minHeight: "35px",
            minWidth: "100px",
            borderRadius: "4px",
            padding: "0px 10px",
            border: "1px solid #00C21F",
            fontWeight: "500",
            fontSize: "18px",
            backgroundColor: `#00C21F`,
            "&:hover": {
              color: "white",
              border: "1px solid #00C21F",
              backgroundColor: "#00C21F",
              fontWeight: "500",
            },
          }}
        >
          {text}
        </Button>
      );
    case "rejected_shipping":
      return (
        <Button
          {...props}
          onClick={props.onClick}
          sx={{
            color: colors?.primary,

            minHeight: "35px",
            minWidth: "100px",
            borderRadius: "4px",
            padding: "0px 10px",
            border: "1px solid #B00020",
            fontWeight: "500",
            fontSize: "18px",
            backgroundColor: `#B00020`,
            "&:hover": {
              color: "white",
              border: "1px solid #B00020",
              backgroundColor: "#B00020",
              fontWeight: "500",
            },
          }}
        >
          {text}
        </Button>
      );
    case "accepted_shipping":
      return (
        <Button
          {...props}
          onClick={props.onClick}
          sx={{
            color: "white",

            minHeight: "35px",
            minWidth: "100px",
            borderRadius: "4px",
            padding: "0px 10px",
            border: "1px solid #52C1FF",
            fontWeight: "500",
            fontSize: "18px",
            backgroundColor: `#52C1FF`,
            "&:hover": {
              color: "white",
              border: "1px solid #52C1FF",
              backgroundColor: "#52C1FF",
              fontWeight: "500",
            },
          }}
        >
          {text}
        </Button>
      );
    case "pending_shipping":
      return (
        <Button
          {...props}
          onClick={props.onClick}
          sx={{
            color: "black",

            minHeight: "35px",
            minWidth: "100px",
            borderRadius: "4px",
            padding: "0px 10px",
            border: "1px solid #FFFF00",
            fontWeight: "500",
            fontSize: "18px",
            backgroundColor: `#FFFF00`,
            "&:hover": {
              color: "black",
              border: "1px solid #FFFF00",
              backgroundColor: "#FFFF00",
              fontWeight: "500",
            },
          }}
        >
          {text}
        </Button>
      );
    case "picked_up_shipping":
      return (
        <Button
          {...props}
          onClick={props.onClick}
          sx={{
            color: "white",

            minHeight: "35px",
            minWidth: "100px",
            borderRadius: "4px",
            padding: "0px 10px",
            border: "1px solid " + colors?.primary,
            fontWeight: "500",
            fontSize: "18px",
            backgroundColor: colors?.primary,
            "&:hover": {
              color: "white",
              border: "1px solid " + colors?.primary,
              backgroundColor: colors?.primary,
              fontWeight: "500",
            },
          }}
        >
          {text}
        </Button>
      );
    case "delivered_shipping":
      return (
        <Button
          {...props}
          onClick={props.onClick}
          sx={{
            color: "white",
            minHeight: "35px",
            minWidth: "100px",
            borderRadius: "4px",
            padding: "0px 10px !important",
            border: "1px solid #00C21F",
            fontWeight: "500",
            fontSize: "18px",
            backgroundColor: `#00C21F`,
            "&:hover": {
              color: "white",
              border: "1px solid #00C21F",
              backgroundColor: "#00C21F",
              fontWeight: "500",
            },
          }}
        >
          {text}
        </Button>
      );
  }
}

export default ButtonSquare;
